/**
 * Tool renderer registrations — single canonical registration point.
 *
 * Side-effect import; loaded once at app start (V2 page imports this for
 * its side effects). When adding a new backend tool that needs a custom UI:
 *   1. Add a `ToolName` constant in `src/types/chat.ts`.
 *   2. Add a renderer component under `assistant/content/`.
 *   3. Register it here with `registerToolRenderer(ToolName.X, Renderer)`.
 *
 * No changes needed in MessageBlock or the page itself.
 */

import { registerToolRenderer } from './tool-registry';
import { ToolName } from '@/types/chat';
import CoursePanel from '@/components/assistant/content/course-panel';
import RagContent from '@/components/assistant/content/rag-content';

registerToolRenderer(ToolName.FIND_COURSES, CoursePanel);
registerToolRenderer(ToolName.BROWSE_AOL_CONTENT, RagContent);
// Unified retrieval tool (P3) renders on the SAME RagContent card as browse.
registerToolRenderer(ToolName.SEARCH_AOL_CONTENT, RagContent);
